function isH5pAppPath(pathname: string): boolean {
  return (
    pathname === '/h5p-core' ||
    pathname.startsWith('/h5p-core/') ||
    pathname === '/h5p-editor' ||
    pathname.startsWith('/h5p-editor/') ||
    pathname === '/api/h5p' ||
    pathname.startsWith('/api/h5p/') ||
    pathname.startsWith('/css/h5p') ||
    pathname.startsWith('/h5p/')
  );
}

export function rebaseH5pUrl(url: string, pageOrigin: string): string {
  if (!url || !pageOrigin) return url;

  let parsed: URL;
  try {
    parsed = new URL(url, pageOrigin);
  } catch {
    return url;
  }

  if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:') return url;
  if (parsed.origin === pageOrigin) return url;

  const path = parsed.pathname;
  const isBareOrigin = path === '/' && parsed.search === '' && parsed.hash === '';
  if (!isBareOrigin && !isH5pAppPath(path)) return url;

  return `${pageOrigin}${path === '/' ? '' : path}${parsed.search}${parsed.hash}`;
}

export function rebaseH5pPayload<T>(payload: T, pageOrigin: string): T {
  if (payload == null || !pageOrigin) return payload;

  if (typeof payload === 'string') {
    return rebaseH5pUrl(payload, pageOrigin) as T;
  }

  if (Array.isArray(payload)) {
    return payload.map((item) => rebaseH5pPayload(item, pageOrigin)) as T;
  }

  if (typeof payload === 'object') {
    const next: Record<string, unknown> = {};
    for (const [key, value] of Object.entries(payload as Record<string, unknown>)) {
      next[key] = rebaseH5pPayload(value, pageOrigin);
    }
    return next as T;
  }

  return payload;
}
